const ATALogo = "https://s3.eu-west-1.amazonaws.com/aryabhattadev.quloi.com/build/logo_ata_email.png"

export const VGMMailBody = () => {
    return`<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
    <div style="width: 100%; background-color: transparent; line-height: inherit;">
      <div>
        <span>Dear Team,</span>
        </br>
        <p>Please find attached VGM documents.
        </br>
      </div>
      <div style="margin-top: 30px;margin-bottom: -30px;">
        Thanks and Regards,
      </div>
      <img src=${ATALogo} alt="ATA Logo" />
    </div>
  </div>`
}